import './App.css';
import About from './Components/Features/About';
import Home from './Components/Features/Home';
import Products from './Components/Features/Products';
import Solutions from './Components/Features/Solutions';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Features/Navbar';
import Contact from './Components/Features/Contact'

function App() {
  return (
    <div className="App">
      <Navbar />
      <section id="home-section">
        <Home />
      </section>
      <section id="about-section">
        <About />
      </section>
      <section id="projects-section">
        <Products />
      </section>
      <section id="solutions-section">
        <Solutions />
      </section>
      <section id="contact-section">
        <Contact/>
      </section>
      <Footer /> 
    </div>
  );
}

export default App;
